import { styled } from 'goober';

import { paths } from '@/routes/helpers/paths';
import { parseSearchParams } from '@/routes/helpers/parse-search-params';
import { RouteLink } from '@/ui/link/route-link';
import type { IconVariant } from '@/ui/icons/icon';
import { Icon } from '@/ui/icons/icon';
import { Tab } from '@/ui/typography/action-panel';

import type { FeedTab } from './feed.state';

const FEED_TAB_ICONS: Partial<Record<FeedTab, IconVariant>> = {
  spotlight: 'Spotlight',
};

export const FeedTabControl = ({ name, id }: { name: string; id: string }) => {
  const icon = FEED_TAB_ICONS[id as FeedTab];

  return (
    <TabLink to={paths.feed() + parseSearchParams({ tab: id })}>
      <TabLabel>
        {icon && <Icon height="16px" icon={icon} width="16px" />}
        <Tab>{name}</Tab>
      </TabLabel>
    </TabLink>
  );
};

const TabLabel = styled('div')`
  align-items: center;
  display: flex;
  gap: 6px;
  white-space: nowrap;
`;

const TabLink = styled(RouteLink)`
  text-decoration: none;
  &:visited {
    color: inherit;
  }
`;
